import { ref, useCssModule, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import { c as createAutofocusProp, u as useAutofocus } from "./assets/useAutofocus-CnLXEQZi.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useFullWidthProp } from "./assets/index-4vIud5LZ.js";
import { X as XIcon, u as useIconProps } from "./assets/XIcon-U9bwokTN.js";
import { u as useInputProps } from "./assets/SingleMessage-Dv2wNb7f.js";
import { u as useValidationsProp } from "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { u as useVModel } from "./assets/index-BJV0_gaH.js";
import XFormField from "./XFormField.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Df_FM1j-.js";
import "./XLink.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-Ca8wHgNc.js";
import "./XTooltip.js";
import "./assets/XDropdown-Bc_0Fycm.js";
import "@floating-ui/dom";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
const XTextInput$1 = "_XTextInput_k936a_1";
const container = "_container_k936a_12";
const hasIcon = "_hasIcon_k936a_17";
const icon = "_icon_k936a_17";
const input = "_input_k936a_27";
const hasError = "_hasError_k936a_30";
const style0 = {
  XTextInput: XTextInput$1,
  container,
  hasIcon,
  icon,
  input,
  hasError
};
const { createIconProps } = useIconProps();
const { createFullWidthProp } = useFullWidthProp();
const { createDisabledProp, getDisabledClass } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const { createValidationsProp } = useValidationsProp();
const { createVModelProp, setupVModel } = useVModel();
const {
  createMessageProps,
  createAdditionalMessagesProp,
  createLabelProps,
  createFormFieldProps,
  createInputProps,
  createRequiredProp
} = useInputProps();
const __default__ = {
  name: "XTextInput",
  components: { XFormField, XIcon },
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    maxlength: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: "on"
    },
    inputClasses: {
      type: Array,
      default: () => []
    },
    inputWidth: {
      type: String,
      default: "100%"
    },
    ...createMessageProps(),
    ...createAdditionalMessagesProp(),
    ...createValidationsProp(),
    ...createLabelProps(),
    ...createFormFieldProps(),
    ...createInputProps(),
    ...createIconProps(),
    ...createVModelProp(),
    ...createAutofocusProp(),
    ...createDisabledProp(),
    ...createFullWidthProp(),
    ...createRequiredProp(),
    ...createTestIdProp()
  },
  emits: ["input", "keyup", "click", "blur", "update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const hasError2 = ref(null);
    const $style = useCssModule();
    const { disabledClass } = getDisabledClass(props);
    const { inputRef } = useAutofocus(props);
    const { data: internalValue } = setupVModel(props, emit);
    const errorClass = computed(() => ({
      [$style.hasError]: hasError2.value
    }));
    const fieldClasses = computed(() => ({
      [$style.hasIcon]: props.icon,
      ...errorClass.value,
      ...disabledClass.value
    }));
    const inputStyles = computed(() => ({
      maxWidth: props.inputWidth
    }));
    function handleError(event) {
      hasError2.value = event;
    }
    return { __sfc: true, createIconProps, createFullWidthProp, createDisabledProp, getDisabledClass, createTestIdProp, setupTestId, createValidationsProp, createVModelProp, setupVModel, createMessageProps, createAdditionalMessagesProp, createLabelProps, createFormFieldProps, createInputProps, createRequiredProp, props, emit, formatTestId, hasError: hasError2, $style, disabledClass, inputRef, internalValue, errorClass, fieldClasses, inputStyles, handleError, XFormField, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.XFormField, _vm._b({ class: [_setup.$style.XTextInput, _setup.fieldClasses], attrs: { "data-testid": _setup.formatTestId("field") }, on: { "error": _setup.handleError }, scopedSlots: _vm._u([{ key: "default", fn: function({ uuid }) {
    return [_vm._t("left"), _c("div", { class: _setup.$style.container }, [_vm.type === "checkbox" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _setup.internalValue, expression: "internalValue" }], ref: "inputRef", class: [_setup.$style.input, _setup.errorClass, ..._vm.inputClasses], style: _setup.inputStyles, attrs: { "id": uuid, "name": _vm.name, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required, "maxlength": _vm.maxlength, "autofocus": _vm.autofocus, "placeholder": _vm.placeholder, "autocomplete": _vm.autocomplete, "data-testid": _setup.formatTestId(), "type": "checkbox" }, domProps: { "checked": Array.isArray(_setup.internalValue) ? _vm._i(_setup.internalValue, null) > -1 : _setup.internalValue }, on: { "keyup": function($event) {
      return _vm.$emit("keyup", $event);
    }, "click": function($event) {
      return _vm.$emit("click", $event);
    }, "blur": function($event) {
      return _vm.$emit("blur", $event);
    }, "change": function($event) {
      var $$a = _setup.internalValue, $$el = $event.target, $$c = $$el.checked ? true : false;
      if (Array.isArray($$a)) {
        var $$v = null, $$i = _vm._i($$a, $$v);
        if ($$el.checked) {
          $$i < 0 && (_setup.internalValue = $$a.concat([$$v]));
        } else {
          $$i > -1 && (_setup.internalValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
        }
      } else {
        _setup.internalValue = $$c;
      }
    } } }) : _vm.type === "radio" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _setup.internalValue, expression: "internalValue" }], ref: "inputRef", class: [_setup.$style.input, _setup.errorClass, ..._vm.inputClasses], style: _setup.inputStyles, attrs: { "id": uuid, "name": _vm.name, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required, "maxlength": _vm.maxlength, "autofocus": _vm.autofocus, "placeholder": _vm.placeholder, "autocomplete": _vm.autocomplete, "data-testid": _setup.formatTestId(), "type": "radio" }, domProps: { "checked": _vm._q(_setup.internalValue, null) }, on: { "keyup": function($event) {
      return _vm.$emit("keyup", $event);
    }, "click": function($event) {
      return _vm.$emit("click", $event);
    }, "blur": function($event) {
      return _vm.$emit("blur", $event);
    }, "change": function($event) {
      _setup.internalValue = null;
    } } }) : _c("input", { directives: [{ name: "model", rawName: "v-model", value: _setup.internalValue, expression: "internalValue" }], ref: "inputRef", class: [_setup.$style.input, _setup.errorClass, ..._vm.inputClasses], style: _setup.inputStyles, attrs: { "id": uuid, "name": _vm.name, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required, "maxlength": _vm.maxlength, "autofocus": _vm.autofocus, "placeholder": _vm.placeholder, "autocomplete": _vm.autocomplete, "data-testid": _setup.formatTestId(), "type": _vm.type }, domProps: { "value": _setup.internalValue }, on: { "keyup": function($event) {
      return _vm.$emit("keyup", $event);
    }, "click": function($event) {
      return _vm.$emit("click", $event);
    }, "blur": function($event) {
      return _vm.$emit("blur", $event);
    }, "input": function($event) {
      if ($event.target.composing) return;
      _setup.internalValue = $event.target.value;
    } } }), _vm.icon ? _c(_setup.XIcon, { class: _setup.$style.icon, attrs: { "icon-style": _vm.iconStyle, "icon": _vm.icon, "fixed-width": "", "data-testid": _setup.formatTestId("icon") } }) : _vm._e()], 1), _vm._t("default")];
  } }], null, true) }, "XFormField", { ..._vm.$props, ..._vm.$attrs }, false));
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XTextInput = __component__.exports;
export {
  XTextInput as default
};
